const NotificationType = {
    EMAIL: 'email',
    PUSH: 'push',
};

export { NotificationType };



// WEBPACK FOOTER //
// ./source/constants/notifications.js